import * as React from "react";
import type { SVGProps } from "react";
const MarketingFirm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_7539)">
      <path
        fill="currentColor"
        d="M21.7507 3.2522c0-.5039-.3047-.961-.7735-1.1563s-1.0039-.086-1.3633.2696l-1.7032 1.707a10 10 0 0 1-7.0706 2.9299h-5.34C4.121 7.0024 3 8.1235 3 9.5024v3.7502c0 1.379 1.1211 2.5001 2.5 2.5001v5.0002c0 .6914.5587 1.25 1.2501 1.25h2.5001a1.2487 1.2487 0 0 0 1.2501-1.25v-5.0002h.3398a10 10 0 0 1 7.0706 2.9298l1.7032 1.7032a1.245 1.245 0 0 0 1.3633.2695c.4688-.1953.7735-.6484.7735-1.1563v-5.7658c.7266-.3438 1.2501-1.2696 1.2501-2.3595s-.5235-2.0157-1.2501-2.3594zm-2.5001 2.9962v10.2582a12.495 12.495 0 0 0-8.4105-3.254h-.3398V9.5025h.3398a12.495 12.495 0 0 0 8.4105-3.254"
      />
    </g>
    <defs>
      <clipPath id="clip0_4362_7539">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default MarketingFirm;
